import React, {useEffect} from 'react';
import {Nav} from 'reactstrap';
import {useSelector, useDispatch} from 'react-redux';
import {fetchErrorLogUnreadCount} from '../../slices/error-logs.slice';
import SidebarShell from './SidebarShell';
import SidebarNavItem from './SidebarNavItem';

const MENU_GROUPS = [
    { section: 'Operate', items: [
        { link: '/', icon: 'fa-home', menuText: 'Home', visibleFor: ['bac-user', 'bac-admin', 'root'] },
        { link: '/orders', icon: 'fa-clipboard-list', menuText: 'Orders', visibleFor: ['bac-user', 'bac-admin', 'root'] },
        { link: '/organizations', icon: 'fa-building', menuText: 'Organizations', visibleFor: ['bac-user', 'bac-admin', 'root'] },
    ] },
    { section: 'Catalogue', items: [
        { link: '/movies', icon: 'fa-film', menuText: 'Movies', visibleFor: ['bac-user', 'bac-admin', 'root'] },
        { link: '/playlists', icon: 'fa-photo-film', menuText: 'Show playlists', visibleFor: ['bac-user', 'bac-admin', 'root'] },
        { link: '/crew-manager', icon: 'fa-user-group', menuText: 'Cast & Crew', visibleFor: ['bac-user', 'bac-admin', 'root'] },
        { link: '/distributors', icon: 'fa-warehouse', menuText: 'Distributors', visibleFor: ['bac-user', 'bac-admin', 'root'] },
    ] },
    { section: 'People', items: [
        { link: '/users', icon: 'fa-users', menuText: 'Users', visibleFor: ['bac-user', 'bac-admin', 'root'] },
    ] },
    { section: 'System', items: [
        { link: '/communications', icon: 'fa-envelope', menuText: 'Communications', visibleFor: ['bac-user', 'bac-admin', 'root'] },
        { link: '/audit', icon: 'fa-list-check', menuText: 'Audit logs', visibleFor: ['bac-user', 'bac-admin', 'root'] },
        { link: '/error-logs', icon: 'fa-bug', menuText: 'Error Logs', visibleFor: ['bac-user', 'bac-admin', 'root'], showErrorBadge: true },
        { link: '/cronjob-notifications', icon: 'fa-robot', menuText: 'Cron Notifications', visibleFor: ['bac-user', 'bac-admin', 'root'] },
    ] },
];

const BACSidebar = ({ isOpen, toggle, organization = null }) => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { unreadCount: errorLogUnreadCount } = useSelector((state) => state.errorLogs);

    useEffect(() => {
        dispatch(fetchErrorLogUnreadCount());
    }, [dispatch]);

    const groups = MENU_GROUPS
        .map(group => ({ ...group, items: group.items.filter(item => item.visibleFor.includes(user.role)) }))
        .filter(group => group.items.length > 0);

    return (
        <SidebarShell isOpen={isOpen} toggle={toggle} organization={organization}>
            <Nav vertical className="sidebar-nav px-3">
                {groups.map(({ section, items }) => (
                    <div key={section} className="nav-group">
                        <div className="nav-section-label text-uppercase">{section}</div>
                        {items.map(({ link, icon, menuText, showErrorBadge }) => (
                            <SidebarNavItem
                                key={link}
                                link={link}
                                icon={icon}
                                menuText={menuText}
                                onClick={toggle}
                                badgeCount={showErrorBadge ? errorLogUnreadCount : 0}
                            />
                        ))}
                    </div>
                ))}
            </Nav>
        </SidebarShell>
    );
};

export default BACSidebar;
